import { resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, vShow as _vShow, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Icons = _resolveComponent("Icons")!

  return _withDirectives((_openBlock(), _createBlock("button", {
    class: "mt-1.5 mb-3 flex items-center gap-x-1 text-base font-semibold font-montserrat text-black-lp-100 mx-auto hover:underline",
    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.onClick && _ctx.onClick(...args))),
    style: {"padding":"10px","box-shadow":"0px 8px 15px 0px #1A142126"}
  }, [
    _createVNode(_component_Icons, {
      name: "chevron-down-new",
      style: {"width":"20px","height":"20px"}
    }),
    _createTextVNode(" " + _toDisplayString(_ctx.$t("cargoV2.components.buttonLoadMore.label")), 1)
  ], 512)), [
    [_vShow, _ctx.dataLength > _ctx.limit]
  ])
}